<template>
  <v-app>
    <LibAppHeader />
    <slot></slot>
    <LibAppFooter />
    <!-- wspólny overlay -->
    <v-overlay style="z-index: 9999999999" :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- wspólne okienko z komunikatem -->
    <v-dialog
      v-model="dialog.show"
      persistent
      width="500"
      content-class="rounded-xl"
    >
      <v-card>
        <v-card-title>
          {{ dialog.title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <div v-html="dialog.text"></div>

          <div class="btn-cont-dialog">
            <v-btn
              title="OK"
              aria-label="OK"
              color="primary"
              v-if="dialog.callback"
              @click="dialog.callback"
              rounded
              large
              depressed
            >
              OK
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- wspólne okienko z zapytaniem -->
    <v-dialog
      v-model="askDialog.show"
      persistent
      width="500"
      content-class="rounded-xl"
      scrollable
    >
      <v-card>
        <v-card-title>
          {{ askDialog.title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <span v-html="askDialog.text"></span>
        </v-card-text>
        <v-card-actions class="border">
          <div class="dialog-actions">
            <v-btn
              :title="askDialog.noLabel"
              text
              v-if="askDialog.noClick"
              @click="askDialog.noClick"
              outlined
              rounded
              large
            >
              {{ askDialog.noLabel }}
            </v-btn>
            <v-btn
              :title="askDialog.yesLabel"
              color="primary"
              :class="`${$vuetify.theme.dark ? 'black--text' : 'white--text'}`"
              v-if="askDialog.yesClick"
              @click="askDialog.yesClick"
              rounded
              depressed
              large
            >
              {{ askDialog.yesLabel }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- powiadomienia -->
    <snackbar-notification v-if="isLogin"></snackbar-notification>
    <CookieBanner></CookieBanner>
  </v-app>
</template>

<script>
import LibAppHeader from "@/components/library/layout/LibAppHeader.vue";
import LibAppFooter from "@/components/library/layout/LibAppFooter.vue";
import { mapGetters } from "vuex";
import SnackbarNotification from "@/components/SnackbarNotification";
import offlineStoreDetect from "@/pwa/offline-store-detect";
import CookieBanner from "../components/CookieBanner.vue";
import { USER_MAIN_ROLE_I } from "@/util/dictionary-code-util.js";

export default {
  name: "LayoutApp",
  components: {
    LibAppHeader,
    LibAppFooter,
    SnackbarNotification,
    CookieBanner
  },
  computed: {
    ...mapGetters({
      overlay: "layout/getOverlay",
      dialog: "layout/getDialog",
      askDialog: "layout/getAskDialog"
    })
  },
  data: () => {
    return {
      firstTime: true
    };
  },
  created() {
    this.$store.dispatch("auth/loadCkobRole");
    this.$store.dispatch("dict/lazyLoad", {
      dictionaryCode: USER_MAIN_ROLE_I,
      archival: false
    });
  },
  mounted() {
    if (this.isLogin && this.firstTime) {
      this.firstTime = false;
      this.$store.dispatch("auth/getNotificationNews");
      if (process.env.NODE_ENV != "dev")
        setInterval(() => {
          this.$store.dispatch("auth/getNotificationNews");
        }, 60000);
    }
    offlineStoreDetect(this.$store);
  }
};
</script>
